import { render, staticRenderFns } from "./CoursewareConfirmBlock.vue?vue&type=template&id=acabefd6&scoped=true&"
import script from "./CoursewareConfirmBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareConfirmBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareConfirmBlock.vue?vue&type=style&index=0&id=acabefd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acabefd6",
  null
  
)

export default component.exports